import axios from "../utils/axios";

export const chatbotApi = {
  sendMessage: async (message, sessionId) => {
    const response = await axios.post("chat", {
      message,
      session_id: sessionId,
    });
    return response.data;
  },

  getHistory: async () => {
    const response = await axios.get("chat/history");
    return response.data;
  },

  getSession: async (sessionId) => {
    const response = await axios.get(`chat/session/${sessionId}`);
    return response.data;
  },

  closeSession: async (sessionId) => {
    const response = await axios.post(`chat/session/${sessionId}/close`);
    return response.data;
  },
};

